import { useEffect } from "react";

import { Box, Button } from "@mui/material";
import { useAppDispatch, useAppSelector } from "@app/store";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import { setMessages, useDeleteMessageMutation, useLazyGetMessagesQuery } from "@modules/messages";

const Messages = () => {
  const dispatch = useAppDispatch();
  const messagesList = useAppSelector((state) => state.message.messages)

  const [getMessages] = useLazyGetMessagesQuery()
  const [deleteMessage] = useDeleteMessageMutation()

  const handleGetRequest = async () => {
    try {
      const messages = await getMessages().unwrap();

      dispatch(setMessages(messages));
    } catch (error) {
      console.log(error);
    }
  };

  const handleDeleteMessage = async (id: string) => {
    if (!id) {
      return null
    }

    try {
      await deleteMessage({ id })
      handleGetRequest()
    } catch (error) {
      console.log(error);
    }
  }

  useEffect(() => {
    handleGetRequest()
  }, [])

  return (
    <Box
      sx={{
        display: 'flex',
        gap: '20px',
        flexDirection: 'column',
        alignItems: 'flex-end'
      }}
    >
      <TableContainer component={Paper}>
        <Table sx={{ minWidth: 650 }} aria-label="simple table">
          <TableHead>
            <TableRow>
              <TableCell align="center">NAME</TableCell>
              <TableCell align="center">SURNAME</TableCell>
              <TableCell align="center">EMAIL</TableCell>
              <TableCell align="center">PHONE</TableCell>
              <TableCell align="center">MESSAGE</TableCell>
              <TableCell align="center">FOLLOWED</TableCell>
              <TableCell align="center">Actions</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {messagesList.map(({
              id,
              name,
              surname,
              email,
              phone,
              message,
              follow,
            }) => {
              return (
                <TableRow key={id}>
                  <TableCell align="center">{name}</TableCell>
                  <TableCell align="center">{surname}</TableCell>
                  <TableCell align="center">{email}</TableCell>
                  <TableCell align="center">{phone}</TableCell>
                  <TableCell align="center">{message}</TableCell>
                  <TableCell align="center">{follow ? 'Yes' : 'No'}</TableCell>
                  <TableCell align="center">
                    <Button
                      onClick={() => handleDeleteMessage(id)}
                    >
                      Delete
                    </Button>
                  </TableCell>
                </TableRow>
              )
            })}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  )
};

export default Messages;
